!<!--  -->
<template>
  <div class="" style="">
   <div class="" style="padding:30px; background: #FFFFFF;
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;">
      <span
        style="
          margin-bottom: 20px;
          width: 71px;
          height: 23px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #343434;
        "
        >收货人</span
      >

      <div
        style="
          width: 147px;
          height: 40px;
          background: #ffffff;
          margin: 30px 0 20px 0;
          border: 1px solid #FF4D01;
          border-radius: 5px;
          text-align: center;
        "
      >
        <span
          @click="dialogVisible = true"
          class="pointer"
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF4D01;
            line-height: 40px;
          "
          >新增收货地址</span
        >
      </div>
      <!-- 地址卡片 -->
      <div>
        <el-card
          v-for="(item, index) in addrList"
          :key="index"
          class="box-card card-hover"
          style="margin-bottom: 20px; border-radius: 10px"
        >
          <div
            style="
              max-height:500px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 40px;
            "
          >
            <div style="">
              <!-- 行1 -->
              <div style="display: flex;align-items: center;">
                <span
                  style="
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #343434;
                  "
                  >{{ item.name }}</span
                >
                <span
                  style="
                    margin-left: 20px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                    max-width: 500px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  >{{ item.tel }}</span
                >
                <!-- <div
                  style="
                    margin-left: 20px;
                    display: inline-block;
                    height: 26px;
                    background: #e8efff;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "

                > -->
                  <span
                   v-if="item.isdefault"
                    style="
                      font-size: 14px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #FF4D01;
                      line-height: 26px;
                      padding: 0 8px 0 8px;
                    "
                    >默认地址</span
                  >
                <!-- </div> -->

                 <div
                  style="

                    display: inline-block;
                    height: 26px;
                    background: rgb(243 247 255);
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "
                  v-if="item.tag"
                >
                  <span
                    style="
                      font-size: 14px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #FF4D01;
                      line-height: 26px;
                      padding: 0 8px 0 8px;
                    "
                    >{{item.tag}}</span
                  >
                </div>
              </div>

              <!-- 行2 -->
              <div style="margin-top: 20px;max-width:1150px">
                <span style="margin-right: 10px">{{ item.country }}</span>
                <span style="margin-right: 10px">{{ item.city }}</span>
                <span style="margin-right: 10px" v-if="item.area">{{
                  item.area
                }}</span>
                <span style="display:inline-block;max-width:700px;vertical-align:top;margin-right: 10px;">{{ item.address }}</span>
              </div>
            </div>

            <div>
              <span @click="setAsDefault(item, index)" v-if="!item.isdefault"
                style="
                  border-right: 1px solid #e7e7e7;
                  padding-right: 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >设为默认</span
              >
              <span @click="edit(item)"
                style="
                  border-right: 1px solid #e7e7e7;
                  padding: 0 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >编辑</span
              >
              <span @click="confirmDelete(item.id)" style="color: #999; padding: 0 20px" class="pointer"
                >删除</span
              >
            </div>
          </div>
        </el-card>
      </div>

      <!-- 新增弹窗 -->
      <el-dialog
       :before-close="handleClose"
        custom-class="class1"
        style="border-radius: 20px"
        :title="this.submitForm.id?'修改收货人地址':'新增收货人地址'"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
      >
        <el-form class=""
                 :model="submitForm"
                 ref="editForm"
                 label-width="80px"
                 @submit.native.prevent>
          <el-form-item label="联系人"
                        prop="name"
                        :rules="formRules.name">
            <el-input v-model="submitForm.name"
                      placeholder="请输入 联系人（20个字符以内）"></el-input>
          </el-form-item>
          <el-form-item label="联系方式"
                        prop="tel"
                        :rules="formRules.tel">
            <el-input v-model="submitForm.tel"
                      placeholder="请输入 联系方式"></el-input>
          </el-form-item>
          <el-form-item label="邮政编码"
                        prop="zipCode"
                        :rules="formRules.zipCode">
            <el-input v-model="submitForm.zipCode"
                      placeholder="请输入 邮政编码"></el-input>
          </el-form-item>
          <el-form-item label="国家"
                        prop="country"
                        :rules="formRules.require">
            <el-select v-model="submitForm.country"
                       placeholder="请选择国家">
              <el-option
                v-for="item in citylist"
                :key="item.namec"
                :label="item.namec"
                :value="item.namec"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="州"
                        prop="city"
                        :rules="formRules.city">
            <el-input v-model="submitForm.city"
                      placeholder="请输入 州（100个字符以内）"></el-input>
          </el-form-item>
          <el-form-item label="城市"
                        prop="area"
                        :rules="formRules.city">
            <el-input v-model="submitForm.area"
                      placeholder="请输入 城市（100个字符以内）"></el-input>
          </el-form-item>
          <el-form-item label="详细地址"
                        prop="address"
                        :rules="formRules.address">
            <el-input v-model="submitForm.address"
                      type="textarea"
                      rows="3"
                      placeholder="请输入 详细地址（200个字符以内）"></el-input>
          </el-form-item>
          <el-form-item label="标签"
                        prop="tag"
                        :rules="formRules.tag">
            <el-input v-model="submitForm.tag"
                      placeholder="请输入 标签（10个字符以内）"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-checkbox v-model="submitForm.isdefault"
                         text-color="#FF4D01"
                         style="margin-right: 10px">
              设置为默认地址
            </el-checkbox>
          </el-form-item>
          <el-form-item label="" label-width="0">
            <div style="text-align: center;">
              <el-button @click="clickAddAddress"
                         style="width: 120px;"
                         type="primary">
                {{this.submitForm.id ? '修改' : '新增'}}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    rulesNotEmpty,
    getRegExpPhone,
    rulesPhone,
  } from "@/assets/js/formRules";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        props:{
            value:'namec',
            label:'namec',
        },

      //新增地址 国家列表
      citylist: [

      ],
      // 新增地址
      submitForm: {
          "address": "",
          "area": "",
          "city": "",
          "country": "",
          "customerid": '',
          "id": '',
          "isdefault": false,
          "name": "",
          "tag": "",
          "tel": "",
          "zipCode": "",//邮政编码
        },
      dialogVisible: false,
      formRules: {
        no: [{trigger: "blur", required: false}],
        require: [rulesNotEmpty()],
        tel: [rulesNotEmpty(),{trigger: "blur", type: 'string',max:100,message:'最多100个字符'}],
        zipCode: [rulesNotEmpty(),{trigger: "blur", type: 'string',max:20,message:'最多20个字符'}],
        phone: [rulesNotEmpty("手机号"), rulesPhone()],
        name:[rulesNotEmpty(),{trigger: "blur", type: 'string',max:20,message:'最多20个字符'}],
        city:[rulesNotEmpty(),{trigger: "blur", type: 'string',max:100,message:'最多100个字符'}],
        address:[rulesNotEmpty(),{trigger: "blur", type: 'string',max:200,message:'最多200个字符'}],
        tag:[{trigger: "blur", type: 'string',max:10,message:'最多10个字符'}],
      },
      // 已有地址列表
      addrList: [],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    /**
     * 点击新增地址
     */
    clickAddAddress(formName) {
      if(!(typeof formName === 'string' && !!formName)) formName = 'editForm'
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          // this.$message.error('新增地址表单数据检验不通过！');
          return false;
        }
        this.addAddr();
      });
    },
    // 设置默认
      setAsDefault(item, index){
          // console.log("item---", item)
          // return
          let form  = new FormData()
          form.append('addressId',item.id)
          this.axios.post(`/customer/updateAddressDefault`, form)
          .then((res) => {
           if (res.data.code == 200) {
             this.$message.info("修改成功!");
             this.getList()
          } else {
           this.$message.info(res.data.message);
           this.getList()
           }
          }) .catch((res) => {
          // console.log(res);
          });
          this.addrList[index].isdefault = true
          // console.log("xxx", this.addrList)
      },
      resetData(){
           for(let key in this.submitForm){
                     this.submitForm[key] = ""
                 }

      },
      handleClose(done) {
              this.dialogVisible = false
              this.resetData()

      },

      edit(item){
          console.log(item)
           this.submitForm.name = item.name
           this.submitForm.country = item.country
           this.submitForm.city = item.city
           this.submitForm.area = item.area
           this.submitForm.id = item.id
           this.submitForm.tel = item.tel
            this.submitForm.address = item.address
           this.submitForm.tag = item.tag
           this.submitForm.isdefault = item.isdefault
           this.submitForm.zipCode = item.zipCode
          this.dialogVisible = true
      },
      // 获取目的国地址列表
      getPopList(){



          this.axios.post('/filedata/findThirdLevelAddress')
          .then(res => {

                    console.log(res)
                    if (res.data.code == 200) {
                      this.citylist = res.data.datas
                    }else{
                                this.$message.info('服务器繁忙')
                            }

                  }).catch(res => {
                            this.$message.info('服务器繁忙')
                  })
      },

    /**
     * 删除
     * @param id
     */
    confirmDelete(id) {



        this.$confirm('此操作将删除该地址, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

              let user = this.sessionGetUserInfo();

                 this.axios
        .post("/customer/delAddress/" + id,
          {}, {
            headers: {

              token: user.token,
            },

				}
        )
        .then((res) => {
         if(res.data.code != 200){
              this.$message("服务器繁忙");
              return
         }
          this.$message("删除成功");
          this.getList()
        })
        .catch((res) => {
          this.$message("服务器繁忙");
        });





        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

    },

    addAddr() {
         let user = this.sessionGetUserInfo();
        // 新增
        this.submitForm.customerid = user.customerid;

      this.axios
        .post("/customer/addOrUpdateConsigner", this.submitForm)
        .then((res) => {
          console.log(res);
          if (res.data.code != 200) {
               this.$message.info(res.data.message);
            return
          }

             this.$message.info( this.submitForm.id ? '修改成功!' : '新增成功!');
              this.getList()
             this.dialogVisible = false
            this.resetData()


        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = this.sessionGetUserInfo();

      this.axios
        .get("/customer/addressListForConsigner/" + user.customerid )
        .then((res) => {
          console.log(res);
          this.addList = res.datas;
          if (res.data.code != 200) {
            this.$message.info("服务器繁忙...");
            return;
          }
           this.addrList = res.data.datas
          // this.addrList = res.data.datas.map((item, index) => {
          //   return {
          //       id: item.id,
          //     name: item.name,
          //     tel: item.tel,
          //     isDefault: item.isdefault,
          //     country: item.country,
          //     city: item.city,
          //     area: item.area,
          //     address: item.address,
          //     tag: item.tag,
          //   };
          // });
          console.log(this.addrList);
        })
        .catch((res) => {
          console.log("falss");
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   获取地址列表
    this.getList();
    // 获取目的国列表
    this.getPopList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style  scoped>
/* @import './../../../assets/css/free.css';
@import url('./../../../assets/css/free.css');  */
.card-hover:hover {
  border: 1px solid #FF4D01;
}
.class1 {
  border-radius: 20px;
}
.pointer {
  cursor: pointer;
}
/* //@import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/ReceivePage.vue